
export const MbbErrorCodes =  {
  WRONG_TCKN: "COR-30810",
  WRONG_PHONE_NUMBER: "COR-30811",
  JOB_TYPE_AND_AGE_DONT_MATCH: "COR-30812",
  PHONE_NUMBER_IN_USE: "COR-30813",
  WRONG_TAX_ID: "COR-30814",
  TAX_ID_NOT_ALLOWED: "COR-30815",
  MERSIS_ERROR: "COR-30816",
  WLF_ERROR: "COR-30819",
  GENERAL_MBB_ERROR: "COR-30820",
  TECHNICAL_ERROR: "COR-30821"
}
